/**
 * Created by Alan Yang on 8/1/17.
 * Description:
 *
 * ------ maintenance history ------
 * Marcus Change Contact effect use smart effect.
 */

import { of as observableOf, Observable } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ContactService } from '../services/contact.service';
import {
    GET_CONTACT_FIRST_PAGE_WITH_KEYWORD, GET_CONTACT_FIRST_PAGE_WITH_KEYWORD_FAILURE,
    GET_CONTACT_FIRST_PAGE_WITH_KEYWORD_SUCCESS, GET_SLIDESHEET_CONTACT, GET_SLIDESHEET_CONTACT_SUCCESS,
    GET_SLIDESHEET_CONTACT_FAILURE
} from '../redux/app.actions';
import {
    GET_CONTACT_NEXT_PAGE_WITH_KEYWORD, GET_CONTACT_NEXT_PAGE_WITH_KEYWORD_FAILURE,
    GET_CONTACT_NEXT_PAGE_WITH_KEYWORD_SUCCESS, CREATE_CONTACT, CREATE_CONTACT_FAILURE,
    CREATE_CONTACT_SUCCESS, EDIT_CONTACT, EDIT_CONTACT_SUCCESS, EDIT_CONTACT_FAILURE
} from '../redux/app.actions';
import { GET_CONTACT, GET_CONTACT_SUCCESS, GET_CONTACT_FAILURE } from '../redux/app.actions';
import { Injectable } from '@angular/core';
import { Contact } from '../models/contact.model';
import { smartEffect } from '../redux/app.reducers';

@Injectable()
export class ContactEffects {

    constructor(
        private _actions$: Actions,
        private _contactService: ContactService,
    ) { }

    getContactListFirstPageWithKeywordEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_CONTACT_FIRST_PAGE_WITH_KEYWORD),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._contactService.getContactList(payload.page, payload.pageSize, payload.keyword).pipe(
            map(response => {
                const contactList = this._contactService.mapContactList(response);
                return ({
                    type: GET_CONTACT_FIRST_PAGE_WITH_KEYWORD_SUCCESS,
                    payload: contactList
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_CONTACT_FIRST_PAGE_WITH_KEYWORD_FAILURE, payload: err.message });
            }))
        ),
    ));

    getContacgtListNextPageWithKeywordEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_CONTACT_NEXT_PAGE_WITH_KEYWORD),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._contactService.getContactList(payload.page, payload.pageSize, payload.keyword).pipe(
            map(response => {
                const contactList = this._contactService.mapContactList(response);
                return ({
                    type: GET_CONTACT_NEXT_PAGE_WITH_KEYWORD_SUCCESS,
                    payload: contactList
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_CONTACT_NEXT_PAGE_WITH_KEYWORD_FAILURE, payload: err.message });
            }))
        ),
    ));

    getContactEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_CONTACT),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._contactService.getContactDetail(payload.id).pipe(
            map(response => {

                const contact = Contact.parse(response, payload['parseTreeNode']);
                return ({
                    type: GET_CONTACT_SUCCESS,
                    payload: contact
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_CONTACT_FAILURE, payload: err.message });
            }))
        ),
    ));

    getSlideSheetContactEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_SLIDESHEET_CONTACT),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._contactService.getContactDetail(payload.id).pipe(
            map(response => {
                const contact = Contact.parse(response, false);
                return ({
                    type: GET_SLIDESHEET_CONTACT_SUCCESS,
                    payload: contact
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_SLIDESHEET_CONTACT_FAILURE, payload: err.message });
            }))
        ),
    ));

    createContactEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CREATE_CONTACT),
        map(action => action as any),
        switchMap((action) => this._contactService.publishContact(action.payload.data).pipe(
            map(response => {
                const contact = Contact.parse(response, false);
                const createContactResult = smartEffect(action, {
                    type: CREATE_CONTACT_SUCCESS,
                    payload: contact
                });
                return createContactResult;
            }),
            catchError(err => {
                const createContactFailure = smartEffect(action, {
                    type: CREATE_CONTACT_FAILURE,
                    payload: err
                });
                return observableOf(createContactFailure);
            }))
        ),
    ));

    editContactEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EDIT_CONTACT),
        map(action => action as any),
        switchMap((action) => this._contactService.editContact(action.payload.data).pipe(
            map(response => {
                const contact = Contact.parse(response, false);
                const editContactResult = smartEffect(action, {
                    type: EDIT_CONTACT_SUCCESS,
                    payload: contact
                });
                return editContactResult;
            }),
            catchError(err => {
                const createContactFailure = smartEffect(action, {
                    type: EDIT_CONTACT_FAILURE,
                    payload: err
                });
                return observableOf(createContactFailure);
            }))
        ),
    ));
}
